module.exports = __webpack_public_path__ + "assets/img/4-1.49d87427.svg";